/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import { usePreparedServices } from "../../../hooks/usePreparedServices";
import ServiceItem from "./ServiceItem";
import ServiceCatalog from "./ServiceCatalog";

const ServicesList = ({ categorized = false }) => {
  const { isLoading, services, noDataToDisplay, categoriesWithServices } = usePreparedServices();

  return (
    <ServiceCatalog
      categorized={categorized}
      items={services}
      categories={categoriesWithServices}
      isLoading={isLoading}
      noDataToDisplay={noDataToDisplay}
      emptyMessage="No services available"
      renderItem={(service, category) => <ServiceItem key={service.id} service={service} category={category} />}
    />
  );
};

export default ServicesList;
